import { pdfCustomFieldsTranslations } from './pdf-custom-fields-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
/** Übersetzungen des visuellen PDF-Vorlagen-Designers; eingebunden über lib/i18n/de.ts. */
export const pdfDesignerDe = {
  customFields: pdfCustomFieldsTranslations.de,
  list: {
    title: 'PDF-Vorlagen',
    subtitle: 'Belegdruckbilder ohne Programmierung gestalten und je Belegart festlegen.',
    cardTitle: 'Vorlagen',
    cardDescription: 'Die Standardvorlage einer Belegart wird beim Druck automatisch verwendet.',
    filter: 'Belegart filtern',
    allTypes: 'Alle Belegarten',
    create: 'Neue Vorlage',
    created: 'Die Vorlage wurde angelegt.',
    createTitle: 'Vorlage anlegen',
    createDescription: 'Wählen Sie Belegart und Ausgangslayout; beides bleibt später änderbar.',
    preset: 'Ausgangslayout',
    presetHint: 'Das Preset legt Ränder, Schrift, Bausteine und Spalten fest.',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    error: 'Die Vorlagen konnten nicht geladen werden.',
    emptyTitle: 'Noch keine Vorlage vorhanden',
    emptyHint: 'Legen Sie eine Vorlage an, um das Druckbild Ihrer Belege zu gestalten.',
    columns: {
      name: 'Name',
      documentType: 'Belegart',
      status: 'Status',
      updatedAt: 'Zuletzt geändert',
    },
  },
  documentTypes: {
    QUOTE: 'Angebot',
    ORDER: 'Auftragsbestätigung',
    DELIVERY_NOTE: 'Lieferschein',
    INVOICE: 'Rechnung',
    PURCHASE_ORDER: 'Bestellung',
    ALL: 'Alle Belegarten',
  },
  presets: {
    CLASSIC_DIN5008: 'Klassisch DIN 5008',
    MODERN_MINIMALIST: 'Modern Minimalist',
    COMPACT: 'Kompakt',
  },
  blocks: {
    RECEIVING_HOURS: deliveryPlanningTranslations.de.receiving,
    TRANSPORT_PLAN: deliveryPlanningTranslations.de.transport,
    LOGO: 'Firmenlogo',
    SENDER_LINE: 'Absenderzeile',
    RECIPIENT_ADDRESS: 'Adressfeld',
    DOCUMENT_META: 'Belegdaten-Box',
    HEADER_TEXT: 'Betreffzeile',
    CUSTOMER_HEADER: 'Kundendaten im Belegkopf',
    ITEMS_TABLE: 'Positionstabelle',
    SHIPPING_SUMMARY: 'Gebinde und Gewicht',
    TOTALS_BLOCK: 'Summenblock',
    GIROCODE_QR: 'GiroCode QR',
    FOOTER_TEXT: 'Zahlungsbedingungen',
    FOOTER_COLUMNS: '3-Spalten-Fußzeile',
    CUSTOM_HTML_TEXT: 'Freitext',
  },
  columns: {
    position: 'Position',
    sku: 'Artikelnummer',
    name: 'Bezeichnung',
    description: 'Beschreibung',
    batchNumber: 'Charge',
    expiryDate: 'MHD',
    quantity: 'Menge',
    unit: 'Einheit',
    unitPrice: 'Einzelpreis',
    discountPercent: 'Rabatt',
    taxRate: 'Steuersatz',
    lineTotal: 'Gesamt netto',
  },
  toolbar: {
    name: 'Vorlagenname',
    isDefault: 'Standard',
    unsaved: 'Nicht gespeicherte Änderungen',
    editMode: 'Bearbeitungsmodus',
    previewMode: 'Echtzeit-PDF-Vorschau',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    resetPreset: 'Auf Preset zurücksetzen',
    duplicate: 'Duplizieren',
    setDefault: 'Als Standard setzen',
    save: 'Speichern & Aktivieren',
  },
  library: {
    title: 'Bausteine',
    usedTitle: 'Verwendete Bausteine',
    add: '{{block}} hinzufügen',
  },
  canvas: {
    dragHandle: 'Baustein verschieben',
    hide: 'Baustein ausblenden',
    show: 'Baustein einblenden',
    remove: 'Baustein entfernen',
    empty: 'Ziehen Sie Bausteine aus der linken Spalte auf die Seite.',
    resizeColumn: 'Breite der Spalte {{column}} anpassen',
    customerHeaderConfigured: 'Felder aus dem gespeicherten Beleglayout',
    customerHeaderFields: '{{count}} ausgewählte Kundendatenfelder',
  },
  inspector: {
    pageTitle: 'Seite',
    marginsTitle: 'Seitenränder (mm)',
    margin: {
      top: 'Oben',
      bottom: 'Unten',
      left: 'Links',
      right: 'Rechts',
    },
    typographyTitle: 'Typografie',
    fontFamily: 'Schriftart',
    baseFontSize: 'Basisgröße (pt)',
    lineHeight: 'Zeilenhöhe',
    colorsTitle: 'Farben',
    primaryColor: 'Primärfarbe',
    secondaryColor: 'Sekundärfarbe',
    textColor: 'Textfarbe',
    din5008Title: 'DIN 5008',
    showFoldMarks: 'Falzmarken anzeigen',
    showPunchMark: 'Lochmarke anzeigen',
    showPageNumbers: 'Seitenzahlen anzeigen',
    visible: 'Sichtbar',
    pageBreakBefore: 'Seitenumbruch davor',
    content: 'Text',
    contentHint: 'Leer lassen, um den am Beleg erfassten Text zu verwenden.',
    positionTitle: 'Position & Abstand',
    positionX: 'X (mm)',
    positionY: 'Y (mm)',
    positionWidth: 'Breite (mm)',
    positionHeight: 'Höhe (mm)',
    paddingTop: 'Abstand oben (mm)',
    paddingBottom: 'Abstand unten (mm)',
    styleTitle: 'Darstellung',
    fontSize: 'Schriftgröße (pt)',
    alignLabel: 'Ausrichtung',
    bold: 'Fett',
    borderBottom: 'Trennlinie unten',
    background: 'Hintergrundfarbe',
    align: {
      left: 'Links',
      center: 'Zentriert',
      right: 'Rechts',
    },
    tableDisplayTitle: 'Tabellendarstellung',
    zebra: 'Zebrastreifen',
    compact: 'Kompakter Zeilenabstand',
    headerBackground: 'Kopfzeile einfärben',
    headerColor: 'Farbe der Kopfzeile',
    columnsTitle: 'Spalten',
    columnLabel: 'Beschriftung',
    totalsTitle: 'Summenblock',
    showTaxBreakdown: 'Steueraufschlüsselung anzeigen',
    showCashDiscount: 'Skonto-Rechner anzeigen',
    girocodeTitle: 'GiroCode',
    qrSize: 'Größe (mm)',
    qrAlign: 'Ausrichtung',
    qrCaption: 'Beschriftung anzeigen',
    logoTitle: 'Logo',
    logoHeight: 'Höhe (mm)',
    showCompanyAddress: 'Firmenanschrift anzeigen',
    paymentTitle: 'Hinweise',
    showPaymentTerms: 'Zahlungsbedingungen anzeigen',
    showTaxNotice: 'Steuerhinweis anzeigen',
    customerHeaderTitle: 'Kundendaten',
    customerHeaderHint:
      'Ausgewählte öffentliche Standardfelder, etwa die USt-ID, zeigen den gespeicherten Belegwert. Hinzufügen aktiviert den Baustein. Zusatzfelder benötigen weiterhin ihre PDF-Freigabe.',
    customerHeaderSharedTypeHint:
      'Diese Vorlage gilt für mehrere Belegarten. Nicht vorhandene oder nicht freigegebene Felder werden je Beleg sicher ausgelassen.',
    customerHeaderColumns: 'Spalten',
    customerHeaderLabels: 'Feldbezeichnungen',
    customerHeaderLayoutDefault: 'Beleglayout übernehmen',
    customerHeaderLabelsShow: 'Immer anzeigen',
    customerHeaderLabelsHide: 'Nur Werte',
    customerHeaderHideEmpty: 'Leere Werte ausblenden',
    customerHeaderFields: 'Feldauswahl',
    customerHeaderUseLayout: 'Beleglayout verwenden',
    customerHeaderAllConfigured:
      'Alle im Beleglayout für PDF freigegebenen Felder werden angezeigt.',
    customerHeaderSelectedCount: '{{count}} Felder gezielt ausgewählt',
    customerHeaderSelected: 'Ausgewählte Kundendatenfelder',
    customerHeaderUnavailableField: 'Nicht mehr verfügbares Feld',
    customerHeaderMoveUp: 'Feld nach oben verschieben',
    customerHeaderMoveDown: 'Feld nach unten verschieben',
    customerHeaderRemove: 'Feld aus der Auswahl entfernen',
    customerHeaderSearch: 'Felder oder Kategorien suchen',
    customerHeaderSource: 'Feldart filtern',
    customerHeaderCategory: 'Kategorie filtern',
    customerHeaderLoadError: 'Die Kundendatenfelder konnten nicht geladen werden.',
    customerHeaderBlocked: 'Dieses Feld darf nicht auf PDF erscheinen.',
    customerHeaderNoFields: 'Keine passenden extern freigegebenen Felder gefunden.',
  },
  meta: {
    addDocument: 'Belegfeld hinzufügen',
    add: 'Kundenfeld hinzufügen',
    rows: 'Zeilen der Belegdaten-Box',
    hint: 'Reihenfolge per Ziehen oder Pfeiltasten ändern. Werte, Labels und PDF-Freigaben stammen aus dem gespeicherten Beleg. Die Box wächst mit dem Inhalt; die tatsächliche Größe sehen Sie in der PDF-Vorschau. Andere Bausteine bleiben unabhängig.',
    showLabel: 'Feldbezeichnung anzeigen',
    hideEmpty: 'Leere Werte ausblenden',
    chooseSample: 'Beispielbeleg zur Prüfung auswählen.',
    loadError:
      'Die Felder oder der Beleg konnten nicht geladen werden. Prüfen Sie Ihre Leserechte.',
    emptyValue: 'Leerer Wert',
    configureLayout: 'PDF-Freigabe im Kundenkopf konfigurieren',
    configureFields: 'Zusatzfelder konfigurieren',
    openDocument: 'Gespeicherte Feldwerte im Beleg prüfen',
    standard: {
      documentNumber: 'Belegnummer',
      documentDate: 'Datum',
      customerNumber: 'Kundennummer',
      contactPerson: 'Ansprechpartner',
      reference: 'Referenz',
      serviceDate: 'Leistungsdatum',
      deliveryDate: 'Lieferdatum',
      validUntil: 'Gültig bis',
      dueDate: 'Fällig am',
    },
    issues: {
      documentMissingSnapshot:
        'Für dieses Belegfeld fehlt ein lesbarer historischer Feldstand. Prüfen Sie die Zusatzfelder und Ihre Leserechte im Beispielbeleg. Aktuelle Felddefinitionen werden nicht als Ersatz verwendet.',
      documentNotReleased:
        'Dieses Belegfeld ist im gespeicherten Feldstand oder aktuell nicht für PDF freigegeben. Prüfen Sie „In PDF anzeigen“ unter Zusatzfelder; die Vorlagenauswahl erteilt keine Freigabe.',
      unavailable:
        'Das Feld ist im aktuellen Feldkatalog nicht verfügbar. Prüfen Sie Belegart, Feldstatus und Leserechte unter Zusatzfelder.',
      missingSnapshot:
        'Kein gespeicherter Wert vorhanden. Prüfen Sie „Gespeicherte Kundendaten“ im Beleg; ergänzen oder aktualisieren Sie das Feld bei Bedarf ausdrücklich im Entwurf. Aktuelle Stammdaten werden nicht eingesetzt.',
      notConfigured:
        'Dieses Feld fehlt im gespeicherten Beleglayout. Prüfen Sie die Kundendatenauswahl im Beleg.',
      private:
        'Interne oder vertrauliche Felder sind für PDF gesperrt. Prüfen Sie die Einstufung unter Zusatzfelder; die Vorlagenauswahl erteilt keine Freigabe.',
      notReleased:
        'Feld oder Bereich ist im gespeicherten Beleg nicht für PDF freigegeben. Prüfen Sie die PDF-Freigabe im Beleg; den Standard für neue Belege konfigurieren Sie unter Kundendaten im Belegkopf.',
      condition:
        'Die gespeicherte Ausgabebedingung ist nicht erfüllt oder das Feld ist geschützt. Prüfen Sie die Kundendaten-Konfiguration im Beleg.',
      empty: 'Der gespeicherte Wert ist leer und wird ausgeblendet.',
    },
  },
  preview: {
    title: 'PDF-Vorschau',
    sample: 'Beispielbeleg',
    refresh: 'Vorschau neu laden',
    updating: 'Vorschau wird aktualisiert …',
    emptyTitle: 'Kein Beispielbeleg vorhanden',
    emptyHint: 'Erfassen Sie einen Beleg dieser Belegart, um die Vorschau zu sehen.',
  },
  editor: {
    loadError: 'Die Vorlage konnte nicht geladen werden.',
    copyName: '{{name}} (Kopie)',
    resetTitle: 'Layout zurücksetzen?',
    resetDescription:
      'Alle Anpassungen dieser Vorlage werden durch das Preset „{{preset}}" ersetzt. Der Schritt lässt sich rückgängig machen.',
  },
  toast: {
    saved: 'Die Vorlage wurde gespeichert.',
    duplicated: 'Die Vorlage wurde dupliziert.',
    defaultSet: 'Die Vorlage ist jetzt Standard für diese Belegart.',
  },
};
